import {IconButton} from '@ui/buttons/icon-button';
import {Trans} from '@ui/i18n/trans';
import {DarkModeIcon} from '@ui/icons/material/DarkMode';
import {LightModeIcon} from '@ui/icons/material/LightMode';
import {Tooltip} from '@ui/tooltip/tooltip';
import {useSettings} from '@ui/settings/use-settings';
import {useThemeSelector} from '@ui/themes/theme-selector-context';

interface Props {
  className?: string;
}

export function ThemeToggleIconButton({className}: Props) {
  const {themes} = useSettings();
  const {selectedTheme, selectTheme} = useThemeSelector();

  if (!selectedTheme || !themes?.user_change) {
    return null;
  }

  const isDark = selectedTheme.is_dark;

  return (
    <Tooltip
      label={
        isDark ? <Trans message="Light mode" /> : <Trans message="Dark mode" />
      }
    >
      <IconButton
        size="md"
        iconSize="md"
        className={className}
        aria-label={isDark ? 'Light mode' : 'Dark mode'}
        onClick={() => selectTheme(isDark ? 'light' : 'dark')}
      >
        {isDark ? <LightModeIcon /> : <DarkModeIcon />}
      </IconButton>
    </Tooltip>
  );
}
